<div>
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">

                    <img class="modal-icon" style="width: 35px;" src="assets/ico/trash-alt-regular.svg" alt="icon">
                    <span class="modal-title" id="modal-basic-title">
                        <span> Confirm Action </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div [innerHTML]="unlinkText"></div>
        <div *ngIf="showProductsDecision" class="mt-3">
            <label class="mb-2" style="display: block; cursor: pointer; width: fit-content;"><input name="options" ng-control="options" type="radio" [value]="'release'"
                    [(ngModel)]="budgetDecision"> Release
                them back to the Order</label>
            <label class="mb-2" style="display: block; cursor: pointer; width: fit-content;"><input name="options" ng-control="options" type="radio" [value]="'migrate'"
                    [(ngModel)]="budgetDecision"> Migrate
                them to another budget</label>
            <div *ngIf="budgetDecision === 'migrate'" class="col-lg-4">
                <form [formGroup]="migrationForm" class="editForm">
                    <apc-form-select formControlName="budgetToMigrate" [items]="budgets" [isObject]="true"
                        [optionDescription]="['description']">
                    </apc-form-select>
                </form>
            </div>

        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn modal-btn" (click)="close(false)">NO</button>
        <button type="button"
            [disabled]="!(budgetDecision === 'release' || (budgetDecision === 'migrate' && migrationForm.valid))"
            class="btn modal-btn" (click)="close(true)">YES</button>
    </div>
</div>